
<template>
  <div id="extra-component-echarts-demo">
    <div class="vx-row match-height">
      <div class="vx-col w-full mx-auto self-center mb-base">
        <trend-filter @selectedModem="getData"></trend-filter>
      </div>
      <div class="vx-col w-full">
        <current-chart ref="current"></current-chart>
      </div>
      <div class="vx-col w-full">
        <voltage-chart ref="voltage"></voltage-chart>
      </div>
      <div class="vx-col w-full">
        <power-factor-chart ref="powerFactor"></power-factor-chart>
      </div>
      <div class="vx-col w-full">
        <active-energy-chart ref="activeEnergy"></active-energy-chart>
      </div>
      <!-- <div class="vx-col w-full md:w-1/2">
        <echarts-polar-chart></echarts-polar-chart>
      </div>-->
      <div class="vx-col w-full">
        <apparent-energy-chart ref="apparentEnergy"></apparent-energy-chart>
      </div>
    </div>
  </div>
</template>

<script>
import VoltageChart from "./VoltageChart";
import CurrentChart from "./CurrentChart";
import PowerFactorChart from "./PowerFactorChart";
import EchartsPolarChart from "./EchartsPolarChart.vue";
import ActiveEnergyChart from "./ActiveEnergyChart";
import ApparentEnergyChart from "./ApparentEnergyChart";
import moment from "moment";

export default {
  data() {
    return {
      myData: "",
      endpoint: this.$store.state.endpoint2
    };
  },
  components: {
    VoltageChart,
    CurrentChart,
    PowerFactorChart,
    EchartsPolarChart,
    ActiveEnergyChart,
    ApparentEnergyChart
  },
  methods: {
    getData(data) {
      console.log(data, this.endpoint);
      var self = this;
      this.myData = data;
      var payload = data[0];
      this.$http.post(this.endpoint + "/api/raw_data", payload).then(
        response => {
          var res = response.data;
          console.log(res);
          var dataRecords = res;
          if (dataRecords.length == 0) {
            console.log("no data found");
            return;
          }
          self.$refs.current.currentData(dataRecords, payload);
          self.$refs.voltage.voltageData(dataRecords, payload);
          self.$refs.powerFactor.powerFactorData(dataRecords, payload);
          self.$refs.activeEnergy.activeEnergyData(dataRecords, payload);
          self.$refs.apparentEnergy.apparentEnergyData(dataRecords, payload);
        },
        error => {
          console.log(error);
        }
      );
    }
  }
};
</script>